import { http } from '@/http/axios.js';

// 变更收货地址
export function updateOrderAddressAPI(data) {
    return http({
        url: '/admin/order/address/edit',
        method: 'post',
        data,
    });
}
// 备注列表
export function getRemarkListAPI(params) {
    return http({
        url: '/admin/order/trace/page',
        method: 'get',
        params,
    });
}
// 添加备注
export function handleAddRemarkAPI(data) {
    return http({
        url: '/admin/order/trace/add',
        method: 'post',
        data,
    });
}
// 紧急联系人列表
export function getRelationListAPI(orderNo) {
    return http({
        url: '/admin/order/member/relation/list',
        method: 'get',
        params: { orderNo },
    });
}
// 校验紧急联系人
export function riskRelationAPI(data) {
    return http({
        url: '/admin/order/member/relation/risk/alert',
        method: 'post',
        data,
    });
}
// 添加紧急联系人
export function addRelationAPI(data) {
    return http({
        url: '/admin/order/member/relation/add',
        method: 'post',
        data,
    });
}
// 编辑紧急联系人
export function editRelationAPI(data) {
    return http({
        url: '/admin/order/member/relation/edit',
        method: 'post',
        data,
    });
}
// 紧急联系人详情
export function getRelationDetailAPI(id) {
    return http({
        url: '/admin/order/member/relation/detail',
        method: 'get',
        params: { id },
    });
}
// 删除紧急联系人
export function delRelationAPI(id) {
    return http({
        url: '/admin/order/member/relation/delete',
        method: 'post',
        data: { id },
    });
}
// 保存工作单位
export function saveMemberProfileAPI(data) {
    return http({
        url: '/admin/member/profile/save',
        method: 'post',
        data,
    });
}
// 是否监管
export function handleEnableAbmAPI(data) {
    return http({
        url: '/admin/order/edit/abm',
        method: 'post',
        data,
    });
}
// 修改零售价
export function updatePriceAPI(data) {
    return http({
        url: '/admin/order/salePrice/edit',
        method: 'post',
        data,
    });
}
// 门店待结算金额计算
export function calcSettleAPI(data) {
    return http({
        url: '/admin/order/settle/calc',
        method: 'post',
        data,
    });
}
//门店结算金额保存
export function saveSettleAPI(data) {
    return http({
        url: '/admin/order/settle/save',
        method: 'post',
        data,
    });
}
//门店待结算金额明细
export function getSettleInfoAPI(params) {
    return http({ url: '/admin/order/settle/info', method: 'get', params });
}

